<header class="header">
  <div class="header__logo">
    <htx-logo
      alt="HTX Logo"
      (logoClick)="logoClicked.emit()"
    ></htx-logo>
  </div>

  <div class="header__right">
    <div class="header__nav" [class.header__nav--hidden]="showMobileMenu()">
      <htx-navigation-list
        [items]="navigationItems()"
        (itemClicked)="navigationItemClicked.emit($event)"
      ></htx-navigation-list>
    </div>

    <div class="header__nav-mobile" [class.header__nav-mobile--visible]="showMobileMenu()">
      <htx-button
        class="header__nav-mobile-button"
        variant="secondary"
        size="medium"
        icon="menu"
        [dropdownItems]="mobileMenuItems()"
        (dropdownItemSelected)="onMobileMenuItemSelected($event)"
      ></htx-button>
    </div>

    <div class="header__extra">
      @if (extraSpaceTemplate(); as template) {
        <ng-container *ngTemplateOutlet="template"></ng-container>
      }
    </div>

    <div class="header__auth">
      @if (availableLangs().length > 1) {
        <div class="header__lang-switcher">
          @for (lang of availableLangs(); track lang; let last = $last) {
            <button
              class="header__lang-btn"
              [class.header__lang-btn--active]="lang === activeLang()"
              (click)="langChanged.emit(lang)"
              [title]="lang.toUpperCase()"
            >
              {{ lang.toUpperCase() }}
            </button>
            @if (!last) {
              <span class="header__lang-divider">|</span>
            }
          }
        </div>
      }
      @if (!isLoggedIn() && isLoginButtonVisible()) {
        <htx-button
          variant="secondary"
          size="medium"
          (buttonClick)="loginClicked.emit()"
        >
          {{ loginButtonLabel() }}
        </htx-button>
      }

      @if (isLoggedIn() && isLogoutButtonVisible()) {
        <htx-button
          variant="secondary"
          size="medium"
          (buttonClick)="logoutClicked.emit()"
        >
          {{ logoutButtonLabel() }}
        </htx-button>
      }
    </div>
  </div>
</header>
